import { SET_MULTISTEP_MODAL_STATE } from "@/config/constants";

export const setMultistepModalState = (data) => (dispatch) => {
	dispatch({ type: SET_MULTISTEP_MODAL_STATE, payload: data });
};

export default setMultistepModalState;
